// extracted by mini-css-extract-plugin
module.exports = {"formItemWidget":"FormItemWidget_formItemWidget__1jAE2","infoIcon":"FormItemWidget_infoIcon__1RNYY"};